var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M676 740h40c13.255 0 24 10.745 24 24h-64v-24z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M684 732h40c13.255 0 24 10.745 24 24h-64v-24z",
    fill: "#E7D4C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M40 449v22c0 17.673-14.327 32-32 32v-54h32z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 441v22c0 17.673-14.327 32-32 32v-54h32z",
    fill: "#E6B000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fill: "#000",
    d: "M1362 92h70v28h-70z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DB38E",
    d: "M1370 84h70v28h-70z"
  })));
}
export default __webpack_public_path__ + "static/media/backgroundImg.93d7d72f.svg";
export { SvgBackgroundImg as ReactComponent };